/**
 * Auth api client — calls our SAME-ORIGIN /api/auth/* proxy routes only.
 * Tokens live in httpOnly cookies set by those routes; this module never
 * sees or stores a token itself.
 */

import type { LoginCredentials, SessionUser } from "@/types/server";

export interface LoginOutcome {
  ok: boolean;
  status: number;
  user: SessionUser | null;
  error: string | null;
}

export async function login(credentials: LoginCredentials): Promise<LoginOutcome> {
  const response = await fetch("/api/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(credentials),
  });
  const data = await response.json().catch(() => null);
  return {
    ok: response.ok,
    status: response.status,
    user: data?.user ?? null,
    error: data?.error ?? null,
  };
}

export async function fetchMe(): Promise<SessionUser | null> {
  const response = await fetch("/api/me", { cache: "no-store" });
  if (!response.ok) return null;
  const data = await response.json().catch(() => null);
  return data?.user ?? null;
}

export async function logout(): Promise<void> {
  await fetch("/api/auth/logout", { method: "POST" });
}
